var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay",class:_vm.show ? 'overlay--active' : ''},[_c('span',{staticClass:"overlay__bg"}),_vm._v(" "),_c('div',{staticClass:"overlay__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }